<div class="text-dark animate__animated" [class]="animationClass()">
    {{ currentMessage() }}
</div>
